export const NroDocumentoColumn = ({ nrodocumento, tipodocumento_nombre }) => {
  return (
    <>
      <h5
        style={{
          margin: 0,
        }}
      >
        {nrodocumento}
      </h5>
      <h6
        style={{
          margin: 0,
        }}
      >
        {tipodocumento_nombre}
      </h6>
    </>
  );
};
